import { useContext } from 'react'
import { PageHeaderContext } from 'src/components/PageHeader/pageHeaderContext'

export default function useBreadcrumbs(params = { id: null }, t = () => {}) {
    const pageHeaderContext = useContext(PageHeaderContext)
    let breadcrumbs = []
    if (pageHeaderContext.breadcrumbs instanceof Function) {
        breadcrumbs = pageHeaderContext.breadcrumbs(params, t)
    } else {
        breadcrumbs = pageHeaderContext.breadcrumbs
    }
    // please also check the legth of the array here
    const previousBreadcrumb = breadcrumbs[breadcrumbs.length - 2] ?? {}
    return { breadcrumbs, previousBreadcrumb }
}
